import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import "./Scheduling.css";

const Scheduling = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login status
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [postContent, setPostContent] = useState("");
  const [scheduledTime, setScheduledTime] = useState(null);
  const [scheduledPosts, setScheduledPosts] = useState([]);

  useEffect(() => {
    // Example check for login status (replace with your actual check logic)
    const userToken = true;
    if (userToken) {
      setIsLoggedIn(true); 
    } else {
      setIsLoggedIn(false); 
    }
  }, []);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleTimeChange = (time) => {
    setScheduledTime(time);
  };

  const handlePostContentChange = (event) => {
    setPostContent(event.target.value);
  };

  const handleSchedulePost = () => {
    if (postContent && scheduledTime) {
      const newPost = {
        content: postContent,
        date: selectedDate.toLocaleDateString(),
        time: scheduledTime.format("HH:mm"),
      };

      setScheduledPosts([...scheduledPosts, newPost]);
      setPostContent("");
      setScheduledTime(null);
    } else {
      alert("Please provide post content and select a time.");
    }
  };

  if (!isLoggedIn) {
    return (
      <div className="text-center ">
        <div className="alert alert-warning background-dark p-5" role="alert">
          <h4 className="alert-heading landing-text-white">You need to log in!</h4>
          <p className="landing-text-white"> Please log in to view your Scheduling Dashboard.</p>
          <div className="d-flex justify-content-center">
            <button className="btn btn-primary m-2" onClick={() => window.location.href = "/dashboard"}>
              Log in
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-5 ">
      <h2 className=" mb-5 ">Schedule Your Post</h2>
      <div className="row g-4">
        <div className="col-lg-6 col-md-12">
          <h5 className="mb-3 text-muted landing-text-white">Select Date</h5>
          <Calendar
            onChange={handleDateChange}
            value={selectedDate}
            className="w-100 shadow-sm rounded-lg p-3 activity-recent background-dark"
          />
        </div>
        <div className="col-lg-6 col-md-12">
          <h5 className="mb-3 text-muted landing-text-white">Select Time</h5>
          <Datetime
            dateFormat={false}
            timeFormat="HH:mm"
            value={scheduledTime}
            onChange={handleTimeChange}
            inputProps={{
              placeholder: "Select Time",
            }}
            className="w-100 shadow-sm rounded-lg background-dark"
          />
          <div className="mb-5 mt-4">
            <h5 className="text-muted landing-text-white">Post Content</h5>
            <textarea
              value={postContent}
              onChange={handlePostContentChange}
              placeholder="Enter your post content here..."
              rows="4"
              className="form-control shadow-sm rounded-lg"
            />
          </div>
          <div className="d-flex justify-content-between mb-5">
            <button
              onClick={handleSchedulePost}
              className="btn btn-primary w-40 shadow-lg"
            >
              Schedule Post
            </button>
            <div className="d-flex align-items-center">
              <h6 className="mb-0 me-3">Preview:</h6>
              <div
                className={`badge ${postContent && scheduledTime
                  ? "bg-info text-dark"
                  : "bg-danger text-white"
                  } p-3 rounded-pill shadow-sm`}
                style={{ cursor: "pointer" }}
              >
                {postContent && scheduledTime
                  ? "Scheduled Post"
                  : "Not Scheduled"}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <h4 className="text-center mb-4 mt-5   text-primary">Scheduled Posts</h4>
        {scheduledPosts.length === 0 ? (
          <p className="text-center">No posts scheduled.</p>
        ) : (
          <table className="table table-bordered table-striped ">
            <thead>
              <tr>
                <th scope="col">
                  <span className="pe-2"><i class="bi bi-body-text text text-success"></i></span>Content
                </th>
                <th scope="col">
                  <span className="pe-2"><i class="bi bi-calendar-check-fill text-muted"></i></span>Date
                </th>
                <th scope="col">
                  <span className="pe-2"><i class="bi bi-clock-fill text-muted"></i></span>Time
                </th>
              </tr>
            </thead>
            <tbody>
              {scheduledPosts.map((post, index) => (
                <tr key={index}>
                  <td>
                    <span className="pe-2"><i class="bi bi-menu-button text-success"></i></span>
                    {post.content}
                  </td>
                  <td>{post.date}</td>
                  <td>{post.time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Scheduling;
